import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const SiteLayout = () => {
  return (
    <div data-testid="site-layout" className="site-layout">
      <Navbar />
      <main data-testid="site-main-content" className="site-main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
